import React, { useMemo, useState } from "react";
// import Select from "react-select";
import { connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import GenericCard from "../../../components/Cards/GenericCard";
import HeaderBar from "../../../components/Header/HeaderBar";
import LoadingIcon from "../../../components/Loaders/LoadingIcon";
import axios from "../../../services/axios/backendAxios";
import {
  format,
  formatDuration,
  intervalToDuration,
  parse,
  subDays,
} from "date-fns";
import { getAuth, getIdToken } from "firebase/auth";
import StandardButton from "../../../components/Buttons/StandardButton";
import DateRangeFilter from "../../../components/DateRangePicker/DateRangeFilter";
import { useInfiniteQuery } from "@tanstack/react-query";
import EmployeeSelect from "../../../components/Filters/EmployeeSelect";

const AdminTimeClockPage = (props) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [perPage] = useState(50);
  const filters = useMemo(
    () => ({
      user_id: searchParams.get("filter[user_id]"),
      start_date: searchParams.get("filter[start_date]")
        ? parse(
            searchParams.get("filter[start_date]"),
            "yyyy-MM-dd",
            new Date(),
          )
        : subDays(new Date(), 30),
      end_date: searchParams.get("filter[end_date]")
        ? parse(searchParams.get("filter[end_date]"), "yyyy-MM-dd", new Date())
        : new Date(),
      company_id: props.currentUser.currentCompanyId,
      long_running:
        searchParams.get("filter[long_running]") === "1" ? "1" : null,
    }),
    [props.currentUser.currentCompanyId, searchParams],
  );

  const timeRecordsQuery = useInfiniteQuery({
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages, lastPageParam) =>
      lastPage.length < perPage ? null : lastPageParam + 1,
    queryKey: ["time-records", "timeclock-page", filters],
    queryFn: async ({ pageParam }) => {
      let params = {
        ...filtersToParams(filters),
        skip: pageParam * perPage,
        take: perPage,
      };
      const resp = await axios.get(
        `timeclock/record?${new URLSearchParams(params)}`,
      );
      return resp.data;
    },
  });

  const dateRange = useMemo(
    () => ({
      startDate: filters.start_date,
      endDate: filters.end_date,
      key: "selection",
    }),
    [filters],
  );

  const downloadReport = async () => {
    // Create a hidden form element
    const form = document.createElement("form");
    form.style.display = "none"; // Hide the form

    // Set form attributes
    form.method = "POST";
    form.action = axios.defaults.baseURL + "/report/timeclock";
    form.target = "_blank"; // Open response in a new tab

    // Append form inputs to the form
    form.appendChild(createInput("filters[companyId]", filters.company_id));
    form.appendChild(
      createInput("filters[from]", format(filters.start_date, "yyyy-MM-dd")),
    );
    form.appendChild(
      createInput("filters[to]", format(filters.end_date, "yyyy-MM-dd")),
    );
    // if (filters.long_running === '1') {
    //   form.appendChild(
    //     createInput("filters[long_running]", '1')
    //   );
    // }
    if (filters.user_id && filters.user_id !== "all") {
      form.appendChild(createInput("filters[user_id]", filters.user_id));
    }
    form.appendChild(
      createInput(
        "authToken",
        await getIdToken(getAuth().currentUser),
        "hidden",
      ),
    );

    // Append the form to the document body
    document.body.appendChild(form);

    // Submit the form
    form.submit();
  };

  return (
    <>
      <div className="flex flex-col items-center">
        <HeaderBar
          buttons={[
            {
              color: "blue",
              label: "New Employee",
              onClick: () => navigate("/admin/employee/new?type=timeclock"),
            },
            {
              color: "blue",
              label: "Add Record",
              onClick: () =>
                navigate(
                  `/admin/timeclock/new${filters.user_id ? "?user_id=" + filters.user_id : ""}`,
                ),
            },
            {
              color: "blue",
              label: "Export Data",
              onClick: () => downloadReport(),
            },
          ]}
          title="Time Clock"
        />
        <div
          className="flex flex-1 flex-col w-full p-10 items-left overflow-y-scroll"
          style={{ minHeight: 600 }}
        >
          <div className="filterBlock flex flex-col md:flex-row md:space-x-3 space-y-3 md:space-y-0 mb-5">
            <DateRangeFilter
              dateRange={dateRange}
              onChange={(v) => {
                setSearchParams((prev) => {
                  prev.set(
                    "filter[start_date]",
                    format(v.startDate, "yyyy-MM-dd"),
                  );
                  prev.set("filter[end_date]", format(v.endDate, "yyyy-MM-dd"));
                  return prev;
                });
              }}
            />
            <EmployeeSelect
              currentCompanyId={props.currentUser.currentCompanyId}
              selectedEmployeeId={filters.user_id}
              setSelectedEmployeeId={(id) =>
                setSearchParams((prev) => {
                  prev.set("filter[user_id]", id);
                  return prev;
                })
              }
              placeholder="Filter by Employee"
              includeOptionForAll={true}
            />
            {/* <Select
              onChange={(value) => {
                console.log(value);
                setSearchParams((prev) => {
                  prev.set("filter[long_running]", value === null ? "" : "1");
                  return prev;
                });
              }}
              options={[{ value: "yes", label: "Only long running records" }]}
              placeholder="Filter by Long Running"
              isClearable={true}
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  borderColor: "#829399",
                }),
              }}
            /> */}
          </div>
          {timeRecordsQuery.isLoading ? (
            <LoadingIcon />
          ) : (
            <div className="w-full">
              {/* Note: the InfiniteScroll component does not play nicely with useInfiniteQuery when it invalidate data.  The scroll comp does not rerender and displays stale data. */}
              {/* <InfiniteScroll
                dataLength={dataLength(timeRecordsQuery)}
                next={timeRecordsQuery.fetchNextPage()}
                hasMore={timeRecordsQuery.hasNextPage}
                loader={<h4>Loading...</h4>}
                endMessage={
                  <p style={{ textAlign: "center" }}>
                    No more records matching your filters
                  </p>
                }
                > */}
              {timeRecordsQuery.data.pages.map((page) =>
                page.map((record) => (
                  <GenericCard
                    title={`${record.user.firstName} ${record.user.lastName}`}
                    key={record._id}
                    onClick={() => {
                      navigate(`/admin/timeclock/${record._id}`);
                    }}
                  >
                    <span>
                      {formatTime(record.startTime)} &rarr;{" "}
                      {record.endTime ? (
                        formatTime(record.endTime)
                      ) : (
                        <span style={{ color: "red" }}>Active Record</span>
                      )}
                    </span>
                    <br />
                    <span>Time worked: {timeWorked(record)}</span>
                  </GenericCard>
                )),
              )}
              {/* </InfiniteScroll> */}
              {timeRecordsQuery.hasNextPage ? (
                // This is necessary since the InfiniteScroll only loads more pages on scroll - if the user has a large screen and all the results fit on it, then more results will never be loaded. You can test this by setting the per page to a small value like 3
                // Also needed now since we have disabled the infinite scroll since it's incompatible.
                <StandardButton
                  color={"blue"}
                  label="Load More Results"
                  loading={timeRecordsQuery.isLoading}
                  onClick={() => {
                    timeRecordsQuery.fetchNextPage();
                  }}
                />
              ) : (
                <p style={{ textAlign: "center" }}>
                  No more records matching your filters
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
const formatTime = (dateString) => {
  const date = new Date(dateString);
  return format(date, "MMM d, yyyy h:mm bbb");
};
const timeWorked = (record) => {
  return formatDuration(
    intervalToDuration({
      start: new Date(record.startTime),
      end: record.endTime ? new Date(record.endTime) : new Date(),
    }),
    {
      format: [
        "years",
        "months",
        "weeks",
        "days",
        "hours",
        "minutes",
        "seconds",
      ],
    },
  );
};

const createInput = (name, value, type) => {
  const input = document.createElement("input");
  input.type = type || "text";
  input.name = name;
  input.value = value;
  return input;
};
function filtersToParams(filters) {
  let toReturn = [];
  for (const key in filters) {
    if (filters[key] === null) {
      continue;
    }
    if (key === "user_id" && filters[key] === "all") {
      continue;
    }
    if (key === "start_date" || key === "end_date") {
      toReturn[`filter[${key}]`] = format(filters[key], "yyyy-MM-dd");
    } else {
      toReturn[`filter[${key}]`] = filters[key];
    }
  }
  return toReturn;
}
// function dataLength(query) {
//   let sum = 0;
//   for (const page of query.data?.pages ?? []) {
//     sum += page?.data?.length ?? 0;
//   }
//   return sum;
// }

const mapStateToProps = (state) => {
  const { currentUser } = state;
  return { currentUser };
};

export default connect(mapStateToProps)(AdminTimeClockPage);
